export default __webpack_public_path__ + "static/media/ic_send.bf135d5e.svg";